<!--  -->
<template>
    <div class="ScanCode">
        <div class="mask" v-show="loginbox">
            <div class="loginbox">
                <div class="logoinfobox">
                    <div class="logodiv">
                        <div>
                            <img src="https://oss.sbooip.com/static/www/pc/assets/images/logobai.png" alt="" class="logo">
                            <div class="adinfo">
                                胜博大数据模型/专利年费监控/专利分析
                            </div>
                        </div>
                        <div class="ai">Ours Ai，专为行业赋能</div>
                        <div class="wangzhi">
                            www.sbooip.com
                        </div>
                    </div>
                    <span class="close" @click="closelogin"><i class="bi bi-x"></i></span>
                </div>
                <div class="login">
                    <div class="title">
                        微信登录
                        <img src="https://oss.sbooip.com/static/www/pc/assets/images/yang45.png" alt="" class="yang45">
                    </div>
                    <div id="login_container"> </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import axiosApi from '@/utils/AxiosReques'
import { reqToken } from '@/api/'
export default {
    name: "ScanCode",
    components: {},
    data() {
        return {
            loginbox: false
        };
    },
    methods: {
        // 调起微信扫码登录
        showlogin() {
            let uuid = uuidv4()
            let href = 'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE1MHB4O30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAyMDBweDt9Ci5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0KLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyO30g'
            this.loginbox =true
            var obj = new WxLogin({
                self_redirect: true,
                id: "login_container",
                appid: "wx737ccdaf39a7467c",
                scope: "snsapi_login",
                redirect_uri: encodeURIComponent("https://www.sbooip.com/api/Login"),
                state: uuid,
                style: "",
                href: href
            })
            // 开启定时器轮询获取code
            let timer = setInterval(async () => {
                try {
                    // 请求code
                    let req = await axiosApi.post('/api/Login/getcode', { uuid })
                    if (req) {
                        if (req.code) {
                            try {
                                // 通过code换取用户信息存入session
                                let res = await reqToken({ code: req.code })
                                if (res) {
                                    // 获取登录信息
                                    let userinfo = await this.getUserInofo()
                                    if (userinfo) {
                                        // 获取登录信息存入vuex
                                        this.SETUSERINFO(userinfo)
                                        this.getGlobalInfos()
                                        // 关闭登录窗口
                                        this.loginbox = false
                                        // 清除定时器
                                        clearInterval(timer)
                                        // 跳转页面
                                        this.$router.push({ name: 'PatentSearch' })
                                    }
                                }
                            } catch (error) {
                                console.error(error)
                            }
                        }
                    } else {
                        // 清除定时器
                        clearInterval(timer)
                    }
                } catch (error) {
                    // 清除定时器
                    console.error(error)
                }
            }, 200);
        },
        closelogin() {
            this.loginbox = false
        }
    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>

.mask {
    width: 100vw;
    height: 100vh;
    background-color: rgba($color: #000000, $alpha: 0.5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999999999;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
}

.ai {
    margin: 80px 0;
    color: white;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
}


.logoin {
    display: flex;
    justify-content: center !important;
    align-items: center !important;
    position: relative;
}

.adinfo {
    color: white;
    margin-top: 16px;
    font-size: 14px;
}

.logo {
    width: 160px !important;
}

.wangzhi {
    color: white;
}

.loginbox {
    display: flex;
    width: 800px;
    background-color: #218cf0;
    position: relative;
    justify-content: space-between;
    border-radius: 6px;
    overflow: hidden;
}

.logoinfobox {
    width: 50%;
    display: flex;
    align-items: center;
    // justify-content: center;
    padding-left: 40px;

    img {
        width: 200px;
    }
}

.impowerBox .qrcode {
    width: 100px;
}

.impowerBox .title {
    display: none;
}

.impowerBox .info {
    width: 200px;
}

.status_icon {
    display: none
}

.impowerBox .status {
    text-align: center;
}

.logoout {
    display: inline-block;
    margin-left: 20px;
}

.login {
    width: 50%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
}

.title {
    width: 100%;
    background-color: white;
    text-align: center;
    font-size: 17px;
    height: 40px;
    margin-bottom: 10px;
    margin-top: 50px;
}

.yang45 {
    position: absolute;
    right: 0;
    top: 0;
    width: 100px;
}

#login_container {
    background-color: white;
    height: 300px !important;
}

.close {
    top: 0;
    left: 0;
    display: block;
    margin-bottom: 24px !important;
    position: absolute !important;
}

.bi-x {
    color: rgb(255, 255, 255) !important;
    font-size: 30px !important;
}

.caodebox {
    background-color: rgb(255, 255, 255);
}

.SonTab {
    position: fixed;
    top: 7rem;
    height: 4rem;
    width: 100vw;
    left: 0;
    background-color: white;
    z-index: 98;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 40px;
    font-size: 15px;
    box-shadow: 0 0 3px rgba($color: #000000, $alpha: 0.3);
}

.sbubox {
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;

    .sbuitem {
        padding: 8px 16px;

        &:hover a {
            color: red;
        }

        position: relative;
    }
}

.userinfobox {
    margin-left: 40px;
    display: flex;
    align-items: center;

    span {
        display: inline-block;
    }

    .number {
        color: orangered !important;
    }
}

.touxaing {
    width: 30px;
    height: 30px;
    margin: 0 10px 0 40px;
    border-radius: 4px;
}

.active {
    color: red !important;
    font-weight: bold;
}

.tips {
    position: absolute;
    border-radius: 20px;
    padding: 2px;
    min-width: 17px;
    text-align: center;
    background-color: red;
    color: white;
    top: -4px;
    right: 4px;
    z-index: 9;
    font-size: 12px;
}
</style>